export const SceneFilterType = {
	Sepia: 'sepia',
	Darken: 'darken',
	Lighten: 'lighten',
	Blur: 'blur',
} as const

export type SceneFilterType = (typeof SceneFilterType)[keyof typeof SceneFilterType]
export const sceneFilterTypes = Object.values(SceneFilterType)

export const sceneFilterTypesText: Record<SceneFilterType, string> = {
	[SceneFilterType.Sepia]: 'Sepia',
	[SceneFilterType.Darken]: 'Assombrir',
	[SceneFilterType.Lighten]: 'Éclaircir',
	[SceneFilterType.Blur]: 'Flouter',
}
